import data from "../../.sourceflow/partner_reasons.json";
import BaseCollection from "@sourceflow-uk/sourceflow-sdk/base_collection";

export const getReasons = (locale = "en") => {
  return new BaseCollection(data, locale).getItems();
};
